// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  height: 99vh;
  width: 100%;
}

.login-form-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 29px;
  max-width: 449px;
}

/* Left side image styling */
.login-row {
  width: 100%;
}
.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
  .ant-checkbox-checked:not(.ant-checkbox-disabled)
  .ant-checkbox-inner {
  background-color: #d2042d;
  border-color: transparent;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #d2042d;
  border-color: #d2042d;
}
.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
  .ant-checkbox-inner,
.ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
  border-color: #e9e0e1;
}
.login-image {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 96vh;
  display: flex;
  color: white;
  position: relative;
}

.gradient-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 12%);
}

.login-form-container {
  display: flex;
  background: #fff;
  padding: 120px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 120vh;
  width: 100%;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.logo-overlay {
  margin-top: 40px;
  margin-left: 28px;
  height: 6% !important;
  cursor: pointer;
}
.login-title {
  font-size: 23px;
  color: #333;
  margin-bottom: 0.2rem;
  font-weight: 700;
}

.login-subtitle {
  color: #777;
  text-align: center;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
}

.login-form {
  width: 100%;
}

.login-button {
  width: 100%;
  background-color: #d2042d;
  border: none;
  font-weight: bold;
  height: 50px;
}

.google-button {
  background-color: #f5f5f5;
  border: none;
  height: 50px;
  font-weight: 600;
  font-size: 16px;

  color: rgb(9, 9, 9);
}

.login-container
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: #f5f5f5;
  border: none;
  width: 100%;
  height: 50px;
  margin-top: 1rem;
  color: rgb(12, 12, 12);
}

.forgot-password {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}

.sign-up-text {
  text-align: center;
  margin-top: 2rem;
  color: #000;
  font-family: Roboto;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 600;
}

.sign-up-text a {
  color: #d2042d;
  text-decoration: underline;
}

/* Media Queries for Responsiveness */
@media only screen and (max-width: 1024px) {
  .login-form-container {
    background: #fff;
    padding: 55px 40px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 100%;
    width: 100%;
  }
  .login-image {
    background-size: cover;
    width: 100%;
    height: 96vh;
    display: flex;
    color: white;
    position: relative;
  }

  .login-form-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 15%;
    width: 100%;
  }
  .logo-overlay {
    margin-top: 30px;
    margin-left: 30px;
    height: 6% !important;
  }

  .login-title {
    font-size: 23px;
  }

  .login-subtitle {
    font-size: 14px;
  }

  .login-title {
    font-size: 23px !important;
    color: #333;
    margin-bottom: 0.2rem;
  }

  .login-subtitle {
    color: #777;
    margin-bottom: 10px !important;
  }

  .login-form {
    max-width: 100%;
  }

  .login-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px !important;
  }

  .google-button {
    background-color: #f5f5f5;
    border: none;
    height: 40px;
    color: rgb(12, 12, 12);
  }

  .forgot-password {
    color: var(--Colors-Primary-500, #d2042d);
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;

    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  .sign-up-text {
    color: #000;
    font-family: Roboto;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
  }

  .sign-up-text a {
    color: #d2042d;
    text-decoration: underline;
  }
}

/* Media Queries for Responsiveness */
@media only screen and (max-width: 768px) {
  .login-form-container {
    display: flex;
    flex-direction: column;
    padding: 55px 15px;
  }

  .login-title {
    font-size: 19px !important;
  }

  .login-subtitle {
    font-size: 12px;
  }

  .sign-up-text {
    text-align: center;
    margin-top: 2rem;
    color: #000;
    font-family: Roboto;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 600;
  }
  .logo-overlay {
    margin-top: 28px;
    margin-left: 28px;
    height: 6% !important;
  }
  .sign-up-text a {
    text-decoration: underline;
  }
  .login-form-wrapper {
    padding-top: 7% !important;
  }
}

@media only screen and (max-width: 480px) {
  .login-image {
    display: none;
  }
  .login-container {
    height: 100vh;
    width: 100%;
  }

  .login-form-container {
    padding: 27.1% 5%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column !important;
  }

  .google-button:active {
    background-color: #f5f5f5 !important;
    color: rgb(12, 12, 12) !important;
    border: none !important;
  }

  .google-button:hover {
    background-color: #f5f5f5 !important;
    color: rgb(12, 12, 12) !important;
    border: none !important;
  }

  .login-title {
    font-size: 15px;
  }

  .login-subtitle {
    font-size: 12px;
  }

  .forgot-password {
    font-size: 12px;
  }

  .sign-up-text {
    text-align: center;
    margin-top: 2rem;
    color: #000;
    font-size: 0.9rem;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/LoginPage/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;IAEjB,+BAA+B;IAC/B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".login-container {\n  height: 99vh;\n  width: 100%;\n}\n\n.login-form-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: 29px;\n  max-width: 449px;\n}\n\n/* Left side image styling */\n.login-row {\n  width: 100%;\n}\n.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover\n  .ant-checkbox-checked:not(.ant-checkbox-disabled)\n  .ant-checkbox-inner {\n  background-color: #d2042d;\n  border-color: transparent;\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #d2042d;\n  border-color: #d2042d;\n}\n.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover\n  .ant-checkbox-inner,\n.ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {\n  border-color: #e9e0e1;\n}\n.login-image {\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 96vh;\n  display: flex;\n  color: white;\n  position: relative;\n}\n\n.gradient-layer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 12%);\n}\n\n.login-form-container {\n  display: flex;\n  background: #fff;\n  padding: 120px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-height: 120vh;\n  width: 100%;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.logo-overlay {\n  margin-top: 40px;\n  margin-left: 28px;\n  height: 6% !important;\n  cursor: pointer;\n}\n.login-title {\n  font-size: 23px;\n  color: #333;\n  margin-bottom: 0.2rem;\n  font-weight: 700;\n}\n\n.login-subtitle {\n  color: #777;\n  text-align: center;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.login-form {\n  width: 100%;\n}\n\n.login-button {\n  width: 100%;\n  background-color: #d2042d;\n  border: none;\n  font-weight: bold;\n  height: 50px;\n}\n\n.google-button {\n  background-color: #f5f5f5;\n  border: none;\n  height: 50px;\n  font-weight: 600;\n  font-size: 16px;\n\n  color: rgb(9, 9, 9);\n}\n\n.login-container\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background-color: #f5f5f5;\n  border: none;\n  width: 100%;\n  height: 50px;\n  margin-top: 1rem;\n  color: rgb(12, 12, 12);\n}\n\n.forgot-password {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n\n.sign-up-text {\n  text-align: center;\n  margin-top: 2rem;\n  color: #000;\n  font-family: Roboto;\n  font-size: 0.9rem;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.sign-up-text a {\n  color: #d2042d;\n  text-decoration: underline;\n}\n\n/* Media Queries for Responsiveness */\n@media only screen and (max-width: 1024px) {\n  .login-form-container {\n    background: #fff;\n    padding: 55px 40px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    max-height: 100%;\n    width: 100%;\n  }\n  .login-image {\n    background-size: cover;\n    width: 100%;\n    height: 96vh;\n    display: flex;\n    color: white;\n    position: relative;\n  }\n\n  .login-form-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 15%;\n    width: 100%;\n  }\n  .logo-overlay {\n    margin-top: 30px;\n    margin-left: 30px;\n    height: 6% !important;\n  }\n\n  .login-title {\n    font-size: 23px;\n  }\n\n  .login-subtitle {\n    font-size: 14px;\n  }\n\n  .login-title {\n    font-size: 23px !important;\n    color: #333;\n    margin-bottom: 0.2rem;\n  }\n\n  .login-subtitle {\n    color: #777;\n    margin-bottom: 10px !important;\n  }\n\n  .login-form {\n    max-width: 100%;\n  }\n\n  .login-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px !important;\n  }\n\n  .google-button {\n    background-color: #f5f5f5;\n    border: none;\n    height: 40px;\n    color: rgb(12, 12, 12);\n  }\n\n  .forgot-password {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-family: Roboto;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    text-decoration-skip-ink: none;\n    text-decoration-thickness: auto;\n    text-underline-offset: auto;\n    text-underline-position: from-font;\n  }\n\n  .sign-up-text {\n    color: #000;\n    font-family: Roboto;\n    font-size: 0.9rem;\n    font-style: normal;\n    font-weight: 500;\n  }\n\n  .sign-up-text a {\n    color: #d2042d;\n    text-decoration: underline;\n  }\n}\n\n/* Media Queries for Responsiveness */\n@media only screen and (max-width: 768px) {\n  .login-form-container {\n    display: flex;\n    flex-direction: column;\n    padding: 55px 15px;\n  }\n\n  .login-title {\n    font-size: 19px !important;\n  }\n\n  .login-subtitle {\n    font-size: 12px;\n  }\n\n  .sign-up-text {\n    text-align: center;\n    margin-top: 2rem;\n    color: #000;\n    font-family: Roboto;\n    font-size: 0.9rem;\n    font-style: normal;\n    font-weight: 600;\n  }\n  .logo-overlay {\n    margin-top: 28px;\n    margin-left: 28px;\n    height: 6% !important;\n  }\n  .sign-up-text a {\n    text-decoration: underline;\n  }\n  .login-form-wrapper {\n    padding-top: 7% !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .login-image {\n    display: none;\n  }\n  .login-container {\n    height: 100vh;\n    width: 100%;\n  }\n\n  .login-form-container {\n    padding: 27.1% 5%;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  .google-button:active {\n    background-color: #f5f5f5 !important;\n    color: rgb(12, 12, 12) !important;\n    border: none !important;\n  }\n\n  .google-button:hover {\n    background-color: #f5f5f5 !important;\n    color: rgb(12, 12, 12) !important;\n    border: none !important;\n  }\n\n  .login-title {\n    font-size: 15px;\n  }\n\n  .login-subtitle {\n    font-size: 12px;\n  }\n\n  .forgot-password {\n    font-size: 12px;\n  }\n\n  .sign-up-text {\n    text-align: center;\n    margin-top: 2rem;\n    color: #000;\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
